export default {
  existing_documents: {
    description:
      'Ați încărcat deja documentele de mai jos. Selectați unul și apăsați trimite, sau încărcați un document nou.',
    sides: {
      front: 'Față',
      back: 'Verso',
    },
    created_at: 'Încărcat: {{date}}',
    expires_at: 'Expiră: {{date}}',
  },
  document_types: {
    owner_document: 'Document de identitate proprietar',
    business_document: 'Document de afacere',
  },
  form: {
    document_type: {
      label: 'Document justificativ de afacere',
      placeholder: 'Selectați tipul documentului',
      options: {
        vat_registration: 'Înregistrare TVA',
        trade_registration: 'Înregistrare comercială',
        trade_license: 'Licență comercială',
        commercial_register_extract: 'Extras din registrul comerțului',
        financial_statements: 'Situații financiare',
        other: 'Altele',
      },
    },
    front: {
      label: 'Față document',
    },
    back: {
      label: 'Verso document (opțional pentru unele documente)',
    },
    expires_at: {
      label: 'Data expirării documentului',
      placeholder: 'Selectați data expirării',
    },
  },
  buttons: {
    select_file: 'Selectați fișier',
    next: 'Înainte',
    back: 'Verso',
    send: 'Trimite',
    upload_new: 'Încarcă document nou',
    use_existing: 'Folosiți un document încărcat',
  },
};
